// extracted by mini-css-extract-plugin
export default {"couponCode":"gwcCNeeZotcm6LsO2BSM","couponCodeTagContainer":"t3SoxG4EFGUcp5zmkvfj","couponCodeCouponCodeAlert":"l3eE0FmoiL41W7hraSan","couponCodeCodeMessage":"hriloarkMXrzGUVhJNok"};